import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface AmtTransferResult {
  merchantOrgName: string;
  merchantOrgRoleId: number;
  amountToTransfer: number;
  currency: string;
  structuredNoteId: number;
  structuredNoteDisplayId: string;
}

export interface SendAmtTransferResult {
  token: string;
  merchantTransfer: AmtTransferResult[];
}

export const sendTransferFundToJVA = async ({
  token,
  merchantTransfer,
}: SendAmtTransferResult) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/transfer-fund-to-fh-junior-investor-va`,
      {
        merchantTransfer: merchantTransfer,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};
